<template>
  <div class="main_slider loading prev-is-clipped">
    <div class="main_slider__wrapper">
      <div
        class="main_slider__slide"
        v-for="(slide, index) in _.get(contentData, 'data.list')"
        :key="index + 'c'"
      >
        <div class="main_slider__slide--text-block flex column wc">
          <h2 class="f-55 bold f-white uppercase">{{ slide.title }}</h2>
          <p class="f-18 regular f-white" v-if="windowWidth >= 768">
            {{ slide.teaser }}
          </p>
          <router-link
            :to="slide.link"
            class="main_slider__slide--read-more button"
          >
            <div
              class="main_slider__slide--read-more__inner  bg-white flex a_center br-6"
            >
              <svg
                id="Group_5_Copy_3"
                data-name="Group 5 Copy 3"
                xmlns="http://www.w3.org/2000/svg"
                width="11.352"
                height="11.351"
                viewBox="0 0 11.352 11.351"
              >
                <path
                  id="Combined_Shape_Copy_2"
                  data-name="Combined Shape Copy 2"
                  d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
                  fill="#613dd1"
                />
              </svg>
              <span class="bold f-light-purple f-14 uppercase">
                {{ slide.link_name }}</span
              >
            </div>
          </router-link>
        </div>
        <div class="main_slider__slide--inner">
          <div class="main_slider__slide--overlay bg-light-purple"></div>

          <img
            :src="slide.images[0].devices.mobile"
            v-if="windowWidth <= 767"
            :alt="
              $route.name == 'PageViewRouter_ge' && slide.seo_title_ge
                ? slide.seo_title_ge
                : $route.name == 'PageViewRouter_en' && slide.seo_title_en
                ? slide.seo_title_en
                : ' '
            "
          />
          <img
            :src="slide.images[0].devices.desktop"
            v-if="
              windowWidth >= 768 && !_.get(slide, 'video_desktop.videoFile.url')
            "
            :alt="
              $route.name == 'PageViewRouter_ge' && slide.seo_title_ge
                ? slide.seo_title_ge
                : $route.name == 'PageViewRouter_en' && slide.seo_title_en
                ? slide.seo_title_en
                : ' '
            "
          />
          <video
            muted
            type="video/mp4"
            :poster="slide.images[0].devices.desktop"
            :src="slide.video_desktop.videoFile.url"
            v-if="
              windowWidth >= 1366 && _.get(slide, 'video_desktop.videoFile.url')
            "
          ></video>
          <video
            muted
            type="video/mp4"
            :poster="slide.images[0].devices.tablet"
            :src="slide.video_tablet.videoFile.url"
            v-if="
              windowWidth >= 768 &&
                windowWidth <= 1365 &&
                _.get(slide, 'video_tablet.videoFile.url')
            "
          ></video>
        </div>
      </div>
      <div
        class="main_slider__slide"
        v-for="(slide, index) in _.get(contentData, 'data.list')"
        :key="index + 'b'"
      >
        <div class="main_slider__slide--text-block flex column wc">
          <h2 class="f-55 bold f-white uppercase">{{ slide.title }}</h2>
          <p class="f-18 regular f-white" v-if="windowWidth >= 768">
            {{ slide.teaser }}
          </p>
          <router-link
            :to="slide.link"
            class="main_slider__slide--read-more button"
          >
            <div
              class="main_slider__slide--read-more__inner  bg-white flex a_center br-6"
            >
              <svg
                id="Group_5_Copy_3"
                data-name="Group 5 Copy 3"
                xmlns="http://www.w3.org/2000/svg"
                width="11.352"
                height="11.351"
                viewBox="0 0 11.352 11.351"
              >
                <path
                  id="Combined_Shape_Copy_2"
                  data-name="Combined Shape Copy 2"
                  d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
                  fill="#613dd1"
                />
              </svg>
              <span class="bold f-light-purple f-14 uppercase">
                {{ slide.link_name }}</span
              >
            </div>
          </router-link>
        </div>
        <div class="main_slider__slide--inner">
          <div class="main_slider__slide--overlay bg-light-purple"></div>

          <img
            :src="slide.images[0].devices.mobile"
            v-if="windowWidth <= 767"
            :alt="
              $route.name == 'PageViewRouter_ge' && slide.seo_title_ge
                ? slide.seo_title_ge
                : $route.name == 'PageViewRouter_en' && slide.seo_title_en
                ? slide.seo_title_en
                : ' '
            "
          />
          <img
            :src="slide.images[0].devices.desktop"
            v-if="
              windowWidth >= 768 && !_.get(slide, 'video_desktop.videoFile.url')
            "
            :alt="
              $route.name == 'PageViewRouter_ge' && slide.seo_title_ge
                ? slide.seo_title_ge
                : $route.name == 'PageViewRouter_en' && slide.seo_title_en
                ? slide.seo_title_en
                : ' '
            "
          />
          <video
            muted
            type="video/mp4"
            :poster="slide.images[0].devices.desktop"
            :src="slide.video_desktop.videoFile.url"
            v-if="
              windowWidth >= 1366 && _.get(slide, 'video_desktop.videoFile.url')
            "
          ></video>
          <video
            muted
            type="video/mp4"
            :poster="slide.images[0].devices.tablet"
            :src="slide.video_tablet.videoFile.url"
            v-if="
              windowWidth >= 768 &&
                windowWidth <= 1365 &&
                _.get(slide, 'video_tablet.videoFile.url')
            "
          ></video>
        </div>
      </div>
      <div
        class="main_slider__slide"
        v-for="(slide, index) in _.get(contentData, 'data.list')"
        :key="index + 'a'"
      >
        <div class="main_slider__slide--text-block flex column wc">
          <h2 class="f-55 bold f-white uppercase">{{ slide.title }}</h2>
          <p class="f-18 regular f-white" v-if="windowWidth >= 768">
            {{ slide.teaser }}
          </p>
          <router-link
            :to="slide.link"
            class="main_slider__slide--read-more button"
          >
            <div
              class="main_slider__slide--read-more__inner  bg-white flex a_center br-6"
            >
              <svg
                id="Group_5_Copy_3"
                data-name="Group 5 Copy 3"
                xmlns="http://www.w3.org/2000/svg"
                width="11.352"
                height="11.351"
                viewBox="0 0 11.352 11.351"
              >
                <path
                  id="Combined_Shape_Copy_2"
                  data-name="Combined Shape Copy 2"
                  d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
                  fill="#613dd1"
                />
              </svg>
              <span class="bold f-light-purple f-14 uppercase">
                {{ slide.link_name }}</span
              >
            </div>
          </router-link>
        </div>
        <div class="main_slider__slide--inner">
          <div class="main_slider__slide--overlay bg-light-purple"></div>

          <img
            :src="slide.images[0].devices.mobile"
            v-if="windowWidth <= 767"
            :alt="
              $route.name == 'PageViewRouter_ge' && slide.seo_title_ge
                ? slide.seo_title_ge
                : $route.name == 'PageViewRouter_en' && slide.seo_title_en
                ? slide.seo_title_en
                : ' '
            "
          />
          <img
            :src="slide.images[0].devices.desktop"
            v-if="
              windowWidth >= 768 && !_.get(slide, 'video_desktop.videoFile.url')
            "
            :alt="
              $route.name == 'PageViewRouter_ge' && slide.seo_title_ge
                ? slide.seo_title_ge
                : $route.name == 'PageViewRouter_en' && slide.seo_title_en
                ? slide.seo_title_en
                : ' '
            "
          />
          <video
            muted
            type="video/mp4"
            :poster="slide.images[0].devices.desktop"
            :src="slide.video_desktop.videoFile.url"
            v-if="
              windowWidth >= 1366 && _.get(slide, 'video_desktop.videoFile.url')
            "
          ></video>
          <video
            muted
            type="video/mp4"
            :poster="slide.images[0].devices.tablet"
            :src="slide.video_tablet.videoFile.url"
            v-if="
              windowWidth >= 768 &&
                windowWidth <= 1365 &&
                _.get(slide, 'video_tablet.videoFile.url')
            "
          ></video>
        </div>
      </div>
    </div>
    <div class="main_slider__navigation container flex">
      <div class="main_slider__navigation--inner  flex a-center j_sb">
        <div
          class="main_slider__navigation--arrow mr-30 pointer main_slider__navigation--arrow--prev"
          @click="slide(false, all_slides)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <g
              id="Group_2500"
              data-name="Group 2500"
              transform="translate(-13 -12.801)"
            >
              <g
                id="Group_5_Copy_3"
                data-name="Group 5 Copy 3"
                transform="translate(13 12.801)"
              >
                <path
                  id="Combined_Shape_Copy_2"
                  data-name="Combined Shape Copy 2"
                  d="M6.175.342a1.167,1.167,0,0,0,0,1.65l3.842,3.842H1.166a1.167,1.167,0,0,0,0,2.334h8.85L6.175,12.008a1.167,1.167,0,1,0,1.65,1.65l5.834-5.833.02-.021.01-.01.01-.01.012-.013.007-.008.013-.015.005-.006.014-.017,0-.005.014-.018,0,0,.013-.018,0,0,.013-.018,0-.006.012-.018,0-.007.01-.016.005-.009.008-.014.007-.012.006-.011.009-.016,0-.007.011-.021v0a1.166,1.166,0,0,0-.24-1.359L7.825.342a1.167,1.167,0,0,0-1.65,0Z"
                  transform="translate(14 14) rotate(180)"
                  fill="#613dd1"
                />
              </g>
            </g>
          </svg>
        </div>

        <div
          class="main_slider__navigation--arrow  main_slider__navigation--arrow--next pointer"
          @click="slide(true, all_slides)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <g
              id="Group_2499"
              data-name="Group 2499"
              transform="translate(-13 -12.801)"
            >
              <g
                id="Group_5_Copy_3"
                data-name="Group 5 Copy 3"
                transform="translate(13 12.801)"
              >
                <path
                  id="Combined_Shape_Copy_2"
                  data-name="Combined Shape Copy 2"
                  d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                  fill="#613dd1"
                />
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["contentData"],
  data() {
    return {
      all_slides: document.querySelectorAll(".main_slider__slide"),
      slide_width: 0,
      step: -(0.484375 * this.windowWidth),
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      trans: 0,
      allow_slide: true
    };
  },
  methods: {
    init_slider(data) {
      let slider_container = document.querySelector(".main_slider");
      let wrapper = document.querySelector(".main_slider__wrapper");
      wrapper.style.transform = `translate3d(${this.step}px, 0px, 0px)`;

      let vids = wrapper.querySelectorAll("video");
      vids.forEach(v => {
        v.currentTime = 0;
      });
      setTimeout(() => {
        slider_container.classList.remove("loading");
        slider_container.classList.add("loaded");
      }, 400);
      setTimeout(() => {
        slider_container.classList.remove("prev-is-clipped");
      }, 1400);
      setTimeout(() => {
        vids.forEach(vid => {
          vid.addEventListener("loadeddata", () => {
            vid.currentTime = 0;
          });
        });
        if (document.querySelector(".main_slider__slide.active video"))
          document.querySelector(
            ".main_slider__slide.active video"
          ).currentTime = 0;

        if (document.querySelector(".main_slider__slide.active video"))
          document
            .querySelector(".main_slider__slide.active video")
            .addEventListener("loadeddata", () =>
              document.querySelector(".main_slider__slide.active video").play()
            );

        // document.querySelector(".main_slider__slide.active video").play();
      }, 600);
      setTimeout(
        () => {
          slider_container.classList.remove("loaded");
        },
        this.windowWidth >= 1366 ? 3300 : 3100
      );
      setTimeout(
        () => {
          slider_container.classList.remove("loaded-ready");
        },
        this.windowWidth >= 1366 ? 3300 : 3100
      );

      for (let j = 0; j < data.length; j++) {
        data[data.length / 3 + 1].classList.add("active");
      }

      let list = [...data];

      let active = document.querySelector(".main_slider__slide.active");
      let active_idx = list.indexOf(active);

      if (active.querySelector("video")) active.querySelector("video").play();
      if (active.querySelector("video"))
        active.querySelector("video").currentTime = 0;
      if (document.querySelector(".to-be-next"))
        document.querySelector(".to-be-next").classList.remove("to-be-next");
      if (document.querySelector(".to-be-prev"))
        document.querySelector(".to-be-prev").classList.remove("to-be-prev");
      if (data[active_idx - 1]) data[active_idx - 1].classList.add("prev");
      if (data[active_idx + 1]) data[active_idx + 1].classList.add("next");
      if (data[active_idx - 2])
        data[active_idx - 2].classList.add("to-be-prev");
      if (data[active_idx + 2])
        data[active_idx + 2].classList.add("to-be-next");

      document.querySelectorAll(".main_slider__slide").forEach(slide => {
        slide.style.setProperty(
          "width",
          `${
            this.windowWidth <= 1919 && this.windowWidth >= 1207
              ? 1110
              : this.windowWidth <= 1206 && this.windowWidth >= 1024
              ? this.windowWidth - 94
              : this.windowWidth <= 1023 && this.windowWidth >= 768
              ? this.windowWidth - 90
              : this.windowWidth <= 767
              ? this.windowWidth - 40
              : this.windowWidth - 680
          }px`
        );

        if (this.windowWidth <= 1023) {
          slide.querySelector(
            ".main_slider__slide--text-block"
          ).style.width = `${this.windowWidth - 133}px`;
        }

        if (slide.querySelector("video"))
          slide.querySelector("video").style.setProperty(
            "width",
            `${
              this.windowWidth >= 2450
                ? this.windowWidth * 0.9
                : this.windowWidth <= 1919 && this.windowWidth >= 1207
                ? 1110 + 150
                : this.windowWidth <= 1206 && this.windowWidth >= 1024
                ? this.windowWidth - 94 + 350
                : this.windowWidth <= 1023 && this.windowWidth >= 768
                ? this.windowWidth - 90 + 100 // aq iyo  (this.windowWidth - 90) +700 mere gadavakete
                : this.windowWidth * 0.75
            }px`
          );
      });
      active.style.setProperty(
        "width",
        `${
          this.windowWidth <= 1919 && this.windowWidth >= 1207
            ? 1110
            : this.windowWidth <= 1206 && this.windowWidth >= 1024
            ? this.windowWidth - 94
            : this.windowWidth <= 1023 && this.windowWidth >= 768
            ? this.windowWidth - 90
            : this.windowWidth <= 767
            ? this.windowWidth - 40
            : this.windowWidth - 680
        }px`
      );

      let touchstartX = 0;
      let touchendX = 0;

      wrapper.addEventListener("mousedown", e => {
        e.preventDefault();
        touchstartX = e.pageX;
        wrapper.style.cursor = "grabbing";
      });

      wrapper.addEventListener("mouseup", e => {
        e.preventDefault();
        touchendX = e.pageX;
        wrapper.style.cursor = "grab";
        //     if (touchendX < touchstartX) this.slide(true, data);
        // if (touchendX > touchstartX) this.slide(false, data);
        if (touchstartX - touchendX > 100) this.slide(true, data);
        if (touchendX - touchstartX > 100) this.slide(false, data);
      });

      wrapper.addEventListener("touchstart", e => {
        touchstartX = e.changedTouches[0].screenX;
      });

      wrapper.addEventListener("touchend", e => {
        touchendX = e.changedTouches[0].screenX;
        //     if (touchendX < touchstartX) this.slide(true, data);
        // if (touchendX > touchstartX) this.slide(false, data);
        if (touchstartX - touchendX > 100) this.slide(true, data);
        if (touchendX - touchstartX > 100) this.slide(false, data);
      });
    },

    slide(left, data) {
      if (this.allow_slide) {
        this.allow_slide = false;
        setTimeout(() => {
          this.allow_slide = true;
        }, 1790);

        let wrapper = document.querySelector(".main_slider__wrapper");
        let next = document.querySelector(".next");
        let prev = document.querySelector(".prev");

        let step = (this.step + wrapper.offsetWidth) % wrapper.offsetWidth;
        let list = [...data];

        let active = document.querySelector(".main_slider__slide.active");
        let active_idx = list.indexOf(active);

        setTimeout(() => {
          if (active_idx == data.length - 1) {
            document
              .querySelector(".main_slider__navigation--arrow--next")
              .classList.add("disabled");
          } else {
            if (
              document
                .querySelector(".main_slider__navigation--arrow--next")
                .classList.contains("disabled")
            )
              document
                .querySelector(".main_slider__navigation--arrow--next")
                .classList.remove("disabled");
          }
        }, 600);

        setTimeout(() => {
          if (active_idx == 0) {
            document
              .querySelector(".main_slider__navigation--arrow--prev")
              .classList.add("disabled");
          } else {
            if (
              document
                .querySelector(".main_slider__navigation--arrow--prev")
                .classList.contains("disabled")
            )
              document
                .querySelector(".main_slider__navigation--arrow--prev")
                .classList.remove("disabled");
          }
        }, 600);

        if (left) {
          if (active_idx !== data.length - 1) {
            if (
              active_idx == data.length - (data.length / 3 + 1) &&
              data.length !== 9
            ) {
              setTimeout(() => {
                let new_act = data.length / 3 + 1;
                data[new_act + 1].classList.add("next");
                data[new_act + 1].classList.remove("prev");
                data[new_act + 1].classList.remove("to-be-prev");
                if (
                  data[new_act + 1].querySelector(
                    " .main_slider__slide--inner video"
                  )
                )
                  data[new_act + 1]
                    .querySelector(" .main_slider__slide--inner video")
                    .classList.add("trans-delay-reset");
                if (
                  data[new_act + 1].querySelector(
                    " .main_slider__slide--inner img"
                  )
                )
                  data[new_act + 1]
                    .querySelector(" .main_slider__slide--inner img")
                    .classList.add("trans-delay-reset");
                data[new_act + 1]
                  .querySelector(" .main_slider__slide--inner")
                  .classList.add("trans-delay-reset");
                data[new_act + 1].querySelector(
                  " .main_slider__slide--inner"
                ).style.left = "0px";
                data[new_act + 1]
                  .querySelector(" .main_slider__slide--inner")
                  .classList.add("is-transitioning");
              }, 1600);
            }
            if (active_idx == 6 && data.length == 9) {
              setTimeout(() => {
                let new_act = data.length / 3 + 1;
                data[new_act + 1].classList.add("next");
                data[new_act + 1].classList.remove("prev");
                data[new_act + 1].classList.remove("to-be-prev");
                if (
                  data[new_act + 1].querySelector(
                    " .main_slider__slide--inner video"
                  )
                )
                  data[new_act + 1]
                    .querySelector(" .main_slider__slide--inner video")
                    .classList.add("trans-delay-reset");
                if (
                  data[new_act + 1].querySelector(
                    " .main_slider__slide--inner img"
                  )
                )
                  data[new_act + 1]
                    .querySelector(" .main_slider__slide--inner img")
                    .classList.add("trans-delay-reset");
                data[new_act + 1]
                  .querySelector(" .main_slider__slide--inner")
                  .classList.add("trans-delay-reset");
                data[new_act + 1].querySelector(
                  " .main_slider__slide--inner"
                ).style.left = "0px";
                data[new_act + 1]
                  .querySelector(" .main_slider__slide--inner")
                  .classList.add("is-transitioning");
              }, 1600);
            }
            if (active_idx == data.length - data.length / 3) {
              setTimeout(() => {
                let new_act = data.length / 3 + 1;

                if (data[new_act + 1].querySelector("video"))
                  data[new_act + 1].querySelector("video").currentTime = 0;
                if (data[new_act - 1].querySelector("video"))
                  data[new_act - 1].querySelector("video").currentTime = data[
                    new_act - 1
                  ].querySelector("video").duration;
                data[new_act + 1].querySelector(
                  " .main_slider__slide--inner"
                ).style.left = "0px";
                data[new_act + 1].classList.add("trans-delay-reset");
                data[new_act + 2].classList.add("to-be-next");
                data[new_act - 1].classList.add("prev");
                data[new_act - 2].classList.add("to-be-prev");
                data[new_act].classList.add("to-be-active");

                console.log(data[new_act - 1].querySelector("video"));
              }, 10);
              setTimeout(() => {
                // mark
                this.trans = 0;
                let new_act = data.length / 3 + 1;
                this.step =
                  this.windowWidth >= 1207 && this.windowWidth <= 1919
                    ? this.slide_width +
                      ((this.windowWidth - 1110) / 2 - 30) +
                      (data.length / 3) * (this.slide_width - 30)
                    : this.windowWidth >= 1024 && this.windowWidth <= 1206
                    ? this.slide_width +
                      (data.length / 3) * (this.slide_width - 47)
                    : this.windowWidth >= 768 && this.windowWidth <= 1023
                    ? this.slide_width +
                      (data.length / 3) * (this.slide_width - 45)
                    : this.windowWidth <= 767
                    ? this.slide_width +
                      (data.length / 3) * (this.slide_width - 20)
                    : this.slide_width +
                      310 +
                      (data.length / 3) * (this.slide_width - 30);
                for (let j = 0; j < data.length; j++) {
                  //  data[j].style.transform = `translateX(${this.trans}px)`;
                  if (
                    data[j] !== data[new_act + 1] &&
                    data[j] !== data[new_act + 2] &&
                    data[j] !== data[new_act - 1] &&
                    data[j] !== data[new_act - 2] &&
                    data[j] !== data[data.length - 2]
                  ) {
                    data[j].classList.remove("prev");
                    data[j].classList.remove("next");
                    data[j].classList.remove("to-be-prev");
                    data[j].classList.remove("to-be-next");
                  }
                }

                active.classList.remove("active");

                data[data.length / 3 + 1].classList.add("active");

                // not this

                wrapper.style.transform = `translate3d(${this.step}px, 0px, 0px)`;
              }, 1680);
              setTimeout(() => {
                let new_act = data.length / 3 + 1;
                data[new_act + 1].classList.remove("trans-delay-reset");
                data[new_act].classList.remove("to-be-active");
                if (
                  data[new_act + 1].querySelector(
                    " .main_slider__slide--inner video"
                  )
                )
                  data[new_act + 1]
                    .querySelector(" .main_slider__slide--inner video")
                    .classList.remove("trans-delay-reset");
                if (
                  data[new_act + 1].querySelector(
                    " .main_slider__slide--inner img"
                  )
                )
                  data[new_act + 1]
                    .querySelector(" .main_slider__slide--inner img")
                    .classList.remove("trans-delay-reset");
                data[new_act + 1]
                  .querySelector(" .main_slider__slide--inner")
                  .classList.remove("trans-delay-reset");
                data[new_act + 1].querySelector(
                  " .main_slider__slide--inner"
                ).style.left = "";
              }, 1730);
              setTimeout(() => {
                let new_act = data.length / 3 + 1;
                for (let j = 0; j < data.length; j++) {
                  data[j].classList.remove("prev");
                  data[j].classList.remove("next");
                  data[j].classList.remove("to-be-prev");
                  data[j].classList.remove("to-be-next");
                }

                data[new_act + 1].classList.remove("prev");
                data[new_act + 1].classList.add("next");
                data[new_act + 2].classList.add("to-be-next");
                data[new_act - 1].classList.add("prev");
                data[new_act - 2].classList.add("to-be-prev");
              }, 1740);
            }
            wrapper.classList.add("is-transitioning");

            setTimeout(() => {
              wrapper.classList.remove("is-transitioning");
            }, 1660);

            wrapper.classList.remove("right");
            wrapper.classList.add("left");
            //   this.trans -= 173;
            for (let j = 0; j < data.length; j++) {
              data[j].classList.add("is-transitioning");
              data[j]
                .querySelector(".main_slider__slide--inner")
                .classList.add("is-transitioning");
              if (data[j].querySelector(".main_slider__slide--inner video"))
                data[j]
                  .querySelector(".main_slider__slide--inner video")
                  .classList.add("is-transitioning");
              if (data[j].querySelector(".main_slider__slide--inner img"))
                data[j]
                  .querySelector(".main_slider__slide--inner img")
                  .classList.add("is-transitioning");

              setTimeout(() => {
                data[j].classList.remove("is-transitioning");
                data[j]
                  .querySelector(".main_slider__slide--inner")
                  .classList.remove("is-transitioning");
                if (data[j].querySelector(".main_slider__slide--inner video"))
                  data[j]
                    .querySelector(".main_slider__slide--inner video")
                    .classList.remove("is-transitioning");
                if (data[j].querySelector(".main_slider__slide--inner img"))
                  data[j]
                    .querySelector(".main_slider__slide--inner img")
                    .classList.remove("is-transitioning");
              }, 1660);
              //    data[j].style.transform = `translateX(${this.trans}px)`;
              if (
                data[active_idx + 1] &&
                data[active_idx + 1].querySelector("video")
              )
                data[active_idx + 1].querySelector("video").currentTime = 0;
              if (
                data[active_idx + 1] &&
                data[active_idx + 1].querySelector("video")
              )
                data[active_idx + 1].querySelector("video").play();
            }

            this.step -=
              active_idx == list.length - 2
                ? this.windowWidth <= 1919 && this.windowWidth >= 1207
                  ? 1110 + 30
                  : this.windowWidth <= 1206 && this.windowWidth >= 1024
                  ? this.windowWidth - 94 + 47
                  : this.windowWidth <= 1023 && this.windowWidth >= 768
                  ? this.windowWidth - 90 + 45
                  : this.windowWidth <= 767
                  ? this.windowWidth - 40 + 20
                  : this.windowWidth - 680 + 30
                : active_idx == 0
                ? this.windowWidth <= 1919 && this.windowWidth >= 1207
                  ? 1110 + 30
                  : this.windowWidth <= 1206 && this.windowWidth >= 1024
                  ? this.windowWidth - 94 + 47
                  : this.windowWidth <= 1023 && this.windowWidth >= 768
                  ? this.windowWidth - 90 + 45
                  : this.windowWidth <= 767
                  ? this.windowWidth - 40 + 20
                  : this.windowWidth - 680 + 30
                : this.windowWidth <= 1919 && this.windowWidth >= 1207
                ? 1110 + 30
                : this.windowWidth <= 1206 && this.windowWidth >= 1024
                ? this.windowWidth - 94 + 47
                : this.windowWidth <= 1023 && this.windowWidth >= 768
                ? this.windowWidth - 90 + 45
                : this.windowWidth <= 767
                ? this.windowWidth - 40 + 20
                : this.windowWidth - 680 + 30; // 1100 იყო (list.length -3 მეწერა მაგის მერე)
            setTimeout(() => {
              wrapper.style.transform = `translate3d(${this.step}px, 0px, 0px)`;
            }, 0);
          }
        } else {
          if (active_idx !== 0) {
            wrapper.classList.add("is-transitioning");
            if (active_idx == 3) {
              setTimeout(() => {
                let new_act = data.length / 3 + 1;
                data[new_act + 1].classList.add("next");
                data[new_act + 1].classList.remove("prev");
                data[new_act + 1].classList.remove("to-be-prev");
                if (data[new_act - 1].querySelector("video"))
                  data[new_act - 1].querySelector("video").currentTime = 0;
                if (data[new_act - 1].querySelector("video"))
                  data[new_act - 1].querySelector("video").pause();
                if (data[new_act + 1].querySelector("video"))
                  data[new_act + 1].querySelector("video").currentTime = data[
                    new_act + 1
                  ].querySelector("video").duration;
                if (data[new_act + 1].querySelector("video"))
                  data[new_act + 1].querySelector("video").pause();
                if (
                  data[new_act + 1].querySelector(
                    " .main_slider__slide--inner video"
                  )
                )
                  data[new_act + 1]
                    .querySelector(" .main_slider__slide--inner video")
                    .classList.add("trans-delay-reset");
                if (
                  data[new_act + 1].querySelector(
                    " .main_slider__slide--inner img"
                  )
                )
                  data[new_act + 1]
                    .querySelector(" .main_slider__slide--inner img")
                    .classList.add("trans-delay-reset");
                data[new_act + 1]
                  .querySelector(" .main_slider__slide--inner")
                  .classList.add("trans-delay-reset");
                data[new_act + 1].querySelector(
                  " .main_slider__slide--inner"
                ).style.left = "0px";
                data[new_act + 1]
                  .querySelector(" .main_slider__slide--inner")
                  .classList.add("is-transitioning");
              }, 1600);
            }
            if (active_idx == 2) {
              setTimeout(() => {
                let new_act = data.length / 3 + 1;

                data[new_act].classList.add("to-be-active");
                data[new_act - 1].classList.add("trans-delay-reset");
                data[new_act].classList.remove("next");
                data[new_act - 1].classList.remove("next");
                data[new_act + 1].querySelector(
                  " .main_slider__slide--inner"
                ).style.left = "0px";

                data[new_act + 1].classList.add("trans-delay-reset");
                data[new_act + 2].classList.add("to-be-next");
                data[new_act - 1].classList.add("prev");

                data[new_act - 2].classList.add("to-be-prev");
              }, 10);
              setTimeout(() => {
                //mark
                console.log('sdsd')
                console.log(this.slide_width)
                this.trans = 0;
                let new_act = data.length / 3 + 1;
                this.step =
                  this.windowWidth >= 1207 && this.windowWidth <= 1919
                    ? this.slide_width +
                      ((this.windowWidth - 1110) / 2 - 30) +
                      (data.length / 3) * (this.slide_width - 30)   
                    : this.windowWidth >= 1024 && this.windowWidth <= 1206
                    ? this.slide_width +
                      (data.length / 3) * (this.slide_width - 47)
                    : this.windowWidth >= 768 && this.windowWidth <= 1023
                    ? this.slide_width +
                      (data.length / 3) * (this.slide_width - 45)
                    : this.windowWidth <= 767
                    ? this.slide_width +
                      (data.length / 3) * (this.slide_width - 20)
                    : this.slide_width +
                      310 +
                      (data.length / 3) * (this.slide_width - 30);
                for (let j = 0; j < data.length; j++) {
                  //  data[j].style.transform = `translateX(${this.trans}px)`;
                  if (
                    data[j] !== data[new_act + 1] &&
                    data[j] !== data[new_act + 2] &&
                    data[j] !== data[new_act - 1] &&
                    data[j] !== data[new_act - 2] &&
                    data[j] !== data[data.length - 2]
                  ) {
                    data[j].classList.remove("prev");
                    data[j].classList.remove("next");
                    data[j].classList.remove("to-be-prev");
                    data[j].classList.remove("to-be-next");
                  }
                }

                active.classList.remove("active");

                data[data.length / 3 + 1].classList.add("active");
                // not this

                wrapper.style.transform = `translate3d(${this.step}px, 0px, 0px)`;
              }, 1680);
              setTimeout(() => {
                let new_act = data.length / 3 + 1;

                data[new_act - 1].classList.remove("trans-delay-reset");
                data[new_act + 1].classList.remove("trans-delay-reset");
                data[new_act].classList.remove("to-be-active");
                if (
                  data[new_act + 1].querySelector(
                    " .main_slider__slide--inner video"
                  )
                )
                  data[new_act + 1]
                    .querySelector(" .main_slider__slide--inner video")
                    .classList.remove("trans-delay-reset");
                if (
                  data[new_act + 1].querySelector(
                    " .main_slider__slide--inner img"
                  )
                )
                  data[new_act + 1]
                    .querySelector(" .main_slider__slide--inner img")
                    .classList.remove("trans-delay-reset");
                data[new_act + 1]
                  .querySelector(" .main_slider__slide--inner")
                  .classList.remove("trans-delay-reset");
                data[new_act + 1].querySelector(
                  " .main_slider__slide--inner"
                ).style.left = "";
                data[new_act - 2].classList.remove("next");
                data[new_act - 2].classList.add("to-be-prev");
              }, 1700);
            }

            setTimeout(() => {
              wrapper.classList.remove("is-transitioning");
            }, 1660);
            wrapper.classList.remove("left");
            wrapper.classList.add("right");
            //    this.trans += 173;
            for (let j = 0; j < data.length; j++) {
              data[j].classList.add("is-transitioning");
              data[j]
                .querySelector(".main_slider__slide--inner")
                .classList.add("is-transitioning");
              if (data[j].querySelector(".main_slider__slide--inner video"))
                data[j]
                  .querySelector(".main_slider__slide--inner video")
                  .classList.add("is-transitioning");
              if (data[j].querySelector(".main_slider__slide--inner img"))
                data[j]
                  .querySelector(".main_slider__slide--inner img")
                  .classList.add("is-transitioning");

              setTimeout(() => {
                data[j].classList.remove("is-transitioning");
                data[j]
                  .querySelector(".main_slider__slide--inner")
                  .classList.remove("is-transitioning");
                if (data[j].querySelector(".main_slider__slide--inner video"))
                  data[j]
                    .querySelector(".main_slider__slide--inner video")
                    .classList.remove("is-transitioning");
                if (data[j].querySelector(".main_slider__slide--inner img"))
                  data[j]
                    .querySelector(".main_slider__slide--inner img")
                    .classList.remove("is-transitioning");
              }, 1660);
              //  data[j].style.transform = `translateX(${this.trans}px)`;
              setTimeout(() => {
                if (
                  data[active_idx - 1] &&
                  data[active_idx - 1].querySelector("video")
                )
                  data[active_idx - 1].querySelector("video").currentTime = 0;
                if (data[active_idx - 1].querySelector("video"))
                  data[active_idx - 1].querySelector("video").play();
              }, 198);
            }

            this.step +=
              active_idx == 1
                ? this.windowWidth <= 1919 && this.windowWidth >= 1207
                  ? 1110 + 30
                  : this.windowWidth <= 1206 && this.windowWidth >= 1024
                  ? this.windowWidth - 94 + 47
                  : this.windowWidth <= 1023 && this.windowWidth >= 768
                  ? this.windowWidth - 90 + 45
                  : this.windowWidth <= 767
                  ? this.windowWidth - 40 + 20
                  : this.windowWidth - 680 + 30
                : active_idx == list.length - 1
                ? this.windowWidth <= 1919 && this.windowWidth >= 1207
                  ? 1110 + 30
                  : this.windowWidth <= 1365 && this.windowWidth >= 1024
                  ? this.windowWidth - 94 + 47
                  : this.windowWidth <= 1023 && this.windowWidth >= 768
                  ? this.windowWidth - 90 + 45
                  : this.windowWidth <= 767
                  ? this.windowWidth - 40 + 20
                  : this.windowWidth - 680 + 30
                : this.windowWidth <= 1919 && this.windowWidth >= 1207
                ? 1110 + 30
                : this.windowWidth <= 1206 && this.windowWidth >= 1024
                ? this.windowWidth - 94 + 47
                : this.windowWidth <= 1023 && this.windowWidth >= 768
                ? this.windowWidth - 90 + 45
                : this.windowWidth <= 767
                ? this.windowWidth - 40 + 20
                : this.windowWidth - 680 + 30;
            setTimeout(() => {
              wrapper.style.transform = `translate3d(${this.step}px, 0px, 0px)`;
            }, 0);
          }
        }

        for (let j = 0; j < data.length; j++) {
          if (left) {
            if (active_idx !== data.length - 1) {
              data[active_idx + 1].classList.add("next-active");
              let active_next = document.querySelector(".next-active");
              let active_prev = document.querySelector(".prev-active");
              if (active.classList.contains("next"))
                active.classList.remove("next");
              if (active.classList.contains("prev"))
                active.classList.remove("prev");
              if (active.classList.contains("to-be-next"))
                active.classList.remove("to-be-next");
              if (active.classList.contains("to-be-prev"))
                active.classList.remove("to-be-prev");
              data[active_idx].classList.remove("active");

              data[active_idx].classList.add("prev-active");

              setTimeout(() => {
                active_next.classList.remove("next-active");
                active_next.classList.remove("next");
                active_next.classList.add("active");
              }, 200);

              setTimeout(() => {
                if (active_prev) active_prev.classList.remove("prev-active");
              }, 360);
              setTimeout(() => {
                active = document.querySelector(".main_slider__slide.active");
                active_idx = list.indexOf(active);
                if (document.querySelector(".to-be-next"))
                  document
                    .querySelector(".to-be-next")
                    .classList.remove("to-be-next");

                if (data[active_idx - 1])
                  data[active_idx - 1].classList.add("prev");
                if (data[active_idx + 1])
                  data[active_idx + 1].classList.add("next");
                if (data[active_idx + 2])
                  data[active_idx + 2].classList.add("to-be-next");
              }, 280);

              setTimeout(() => {
                if (document.querySelector(".to-be-prev"))
                  document
                    .querySelector(".to-be-prev")
                    .classList.remove("to-be-prev");
                if (data[active_idx - 2])
                  data[active_idx - 2].classList.add("to-be-prev");
              }, 590);
            }
          } else {
            if (active_idx !== 0) {
              active = document.querySelector(".main_slider__slide.active");
              active_idx = list.indexOf(active);
              let active_prev;
              setTimeout(() => {
                data[active_idx - 1].classList.add("prev-active");
                active_prev = document.querySelector(".prev-active");
              }, 120);

              setTimeout(() => {
                if (active.classList.contains("next"))
                  active.classList.remove("next");
                if (active.classList.contains("prev"))
                  active.classList.remove("prev");
                if (active) active.classList.remove("active");
                if (active_prev) active_prev.classList.remove("prev-active");
                if (active_prev) active_prev.classList.add("active");
              }, 200);

              setTimeout(() => {
                if (document.querySelector(".to-be-next"))
                  document
                    .querySelector(".to-be-next")
                    .classList.remove("to-be-next");
                if (document.querySelector(".to-be-prev"))
                  document
                    .querySelector(".to-be-prev")
                    .classList.remove("to-be-prev");
                active = document.querySelector(".main_slider__slide.active");
                active_idx = list.indexOf(active);
                if (document.querySelector("prev"))
                  document.querySelector("prev").classList.remove("prev");
                if (document.querySelector("next"))
                  document.querySelector("next").classList.remove("next");
                if (document.querySelector(".to-be-prev"))
                  document
                    .querySelector(".to-be-prev")
                    .classList.remove("to-be-prev");
                if (document.querySelector(".to-be-next"))
                  document
                    .querySelector(".to-be-next")
                    .classList.remove("to-be-next");

                if (data[active_idx - 1])
                  data[active_idx - 1].classList.add("prev");
                if (data[active_idx + 1])
                  data[active_idx + 1].classList.add("next");
                if (data[active_idx - 2])
                  data[active_idx - 2].classList.add("to-be-prev");
                if (data[active_idx + 2])
                  data[active_idx + 2].classList.add("to-be-next");
              }, 280);
            }
          }
        }
      }
    },

    resize_handler() {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    }
  },

  mounted() {
    let slides = document.querySelectorAll(".main_slider__slide");
    // this.trans = -(173 *  (slides.length / 3 ));
    this.trans = 0;
    if (this.windowWidth >= 1920) {
      this.slide_width = -(this.windowWidth - 680);
      // this.step = this.slide_width + 135;
      // mark
      // this.step = ((this.slide_width) * ((slides.length / 3 ) + 1)) - (this.trans - 193);
      this.step =
        this.slide_width + 310 + (slides.length / 3) * (this.slide_width - 30);
    } else if (this.windowWidth <= 1919 && this.windowWidth >= 1207) {
      this.slide_width = -1110;
      // this.step = this.slide_width + 135;
      this.step =
        this.slide_width +
        ((this.windowWidth - 1110) / 2 - 30) +
        (slides.length / 3) * (this.slide_width - 30);
    } else if (this.windowWidth <= 1206 && this.windowWidth >= 1024) {
      this.slide_width = -(this.windowWidth - 94);
      this.step =
        this.slide_width + (slides.length / 3) * (this.slide_width - 47);
    } else if (this.windowWidth <= 1023 && this.windowWidth >= 768) {
      this.slide_width = -(this.windowWidth - 90);
      this.step =
        this.slide_width + (slides.length / 3) * (this.slide_width - 45);
    } else if (this.windowWidth <= 767) {
      this.slide_width = -(this.windowWidth - 40);
      this.step =
        this.slide_width + (slides.length / 3) * (this.slide_width - 20);
    }

    slides = document.querySelectorAll(".main_slider__slide");
    this.all_slides = slides;
    this.init_slider(slides);

    window.addEventListener("resize", this.resize_handler);
  },
  watch: {
    contentData(ns, os) {
      this.loaded_all = true;
    },
    windowWidth(ns, os) {
      let slides = document.querySelectorAll(".main_slider__slide");
      slides.forEach(slide => {
        slide.classList.remove("active");
        slide.classList.remove("next");
        slide.classList.remove("prev");
        slide.classList.remove("to-be-prev");
        slide.classList.remove("to-be-next");
      });
      if (this.windowWidth >= 1920) {
        this.slide_width = -(this.windowWidth - 680);
        // this.step = this.slide_width + 135;
        // mark
        // this.step = ((this.slide_width) * ((slides.length / 3 ) + 1)) - (this.trans - 193);
        this.step =
          this.slide_width +
          310 +
          (slides.length / 3) * (this.slide_width - 30);
      } else if (this.windowWidth <= 1919 && this.windowWidth >= 1207) {
        this.slide_width = -1110;
        // this.step = this.slide_width + 135;
        this.step =
          this.slide_width +
          ((this.windowWidth - 1110) / 2 - 30) +
          (slides.length / 3) * (this.slide_width - 30);
      } else if (this.windowWidth <= 1206 && this.windowWidth >= 1024) {
        this.slide_width = -(this.windowWidth - 94);
        this.step =
          this.slide_width + (slides.length / 3) * (this.slide_width - 47);
      } else if (this.windowWidth <= 1023 && this.windowWidth >= 768) {
        this.slide_width = -(this.windowWidth - 90);
        this.step =
          this.slide_width + (slides.length / 3) * (this.slide_width - 45);
      } else if (this.windowWidth <= 767) {
        this.slide_width = -(this.windowWidth - 40);
        this.step =
          this.slide_width + (slides.length / 3) * (this.slide_width - 20);
      }

      this.init_slider(slides);
    }
  }
};
</script>
<style lang="scss">
body {
  // position: relative;

  //  &::after{
  //     content: '';
  //     position: absolute;
  //     height: 100vh;
  //     top: 0;
  //     right: 405px;
  //     width: 2px;
  //     background-color: red;
  //       z-index: 999;
  //       @media (max-width: 1919px){
  //           right: 165px;
  //       }
  //          @media (max-width: 1365px){
  //          right: 47px;
  //       }
  //             @media (max-width: 1023px){
  //          right: 45px;
  //       }
  //               @media (max-width: 767px){
  //          right: 20px;
  //       }
  // }
  //   &::before{
  //       content: '';
  //     position: absolute;
  //     height: 100vh;
  //     top: 0;
  //     left: 405px;
  //     width: 2px;
  //     background-color: red;
  //     z-index: 999;
  //         @media (max-width: 1919px){
  //          left: 165px;
  //       }
  //          @media (max-width: 1365px){
  //          left: 47px;
  //       }
  //           @media (max-width: 1023px){
  //          left: 45px;
  //       }
  //          @media (max-width: 767px){
  //          left: 20px;
  //       }
  // }
}
</style>
<style lang="scss" scoped></style>
